import { ReactElement } from 'react';
import { Wrapper } from './JobHistory.elements';
import { Text } from '../Text';

type Props = {
  employer: string;
  url?: string;
  location: string;
  title: string;
  startDate: string;
  endDate: string;
  description: string[];
};
export const JobHistory = (props: Props): ReactElement => {
  return (
    <Wrapper>
      <Text size="standard">{props.title}</Text>
      <br />
      <Text size="standard">
        {props.url ? (
          <a href={props.url} target="_blank" rel="noreferrer">
            {props.employer}
          </a>
        ) : (
          props.employer
        )}{' '}
        - {props.location}
      </Text>
      <br />
      <Text size="small">
        {props.startDate} - {props.endDate}
      </Text>
      <Text tag="p">
        <ul>
          {props.description.map((line, index) => (
            <li id={`${props.employer}-${index}`}>{line}</li>
          ))}
        </ul>
      </Text>
    </Wrapper>
  );
};
